<template>
  <footer id="pre-registro">
    <div class="footer">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-md-3 section-footer">
            <img
              src="@/assets/images/unipol/logo/ssc.png"
              alt="Gobierno de la Ciudad de México"
              class="img-fluid"
            >
            <p>
              <span>Dirección: </span>
              Calz. Desierto de los Leones 5715, Olivar de los Padres, Álvaro
              Obregón, 01870 Ciudad de México, CDMX
            </p>
            <p>
              <span>Teléfono:</span>
              54902959 ó 54902941
            </p>
            <p>
              <span>Correo electrónico:</span>
              desarrolloeducativo@ssp.cdmx.gob.mx
            </p>
          </div>
          <div class="col-md-8 section-footer">
            <div class="container">
              <div class="row justify-content-between">
                <div class="col-md-6 section-footer">
                  <h6>Universidad de la Policía</h6>
                  <scrollactive
                    active-class="active"
                    :offset="80"
                    tag="div"
                  >
                    <ul class="map-site">
                      <li>
                        <a
                          href="#inicio"
                          class="link scrollactive-item"
                        >Inicio</a>
                      </li>
                      <li>
                        <a
                          href="#convocatorias"
                          class="link scrollactive-item"
                        >Convocatorias</a>
                      </li>
                    </ul>
                  </scrollactive>
                </div>
                <div class="col-md-6 section-footer">
                  <h6>Redes Sociales</h6>
                  <ul class="social-section">
                    <li>
                      <a
                        href="https://es-la.facebook.com/PoliciaCDMX/"
                        target="_blank"
                      >
                        <feather-icon
                          icon="FacebookIcon"
                          size="25"
                          class="ml-2 text-info"
                          badge-classes="badge-prymari"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://twitter.com/SSC_CDMX"
                        target="_blank"
                      >
                        <feather-icon
                          icon="TwitterIcon"
                          size="25"
                          class="ml-2 text-info"
                          badge-classes="badge-prymari"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/policia_cdmx/"
                        target="_blank"
                      >
                        <feather-icon
                          icon="InstagramIcon"
                          size="25"
                          class="ml-2 text-info"
                          badge-classes="badge-prymari"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/channel/UC5N4Gt4irqys5S75qc0fpFg"
                        target="_blank"
                      >
                        <feather-icon
                          icon="YoutubeIcon"
                          size="25"
                          class="ml-2 text-info"
                          badge-classes="badge-prymari"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="col-md-12 mt-5">
                  <p style="text-align: justify;">
                    En esta institución no se discrimina por ninguna razón, orientación sexual, identidad de género, adscripción indígena, religión, condición social, estado civil, o cualquier otro motivo que atente con la dignidad humana.
                  </p>
                  <h5 style="font-weight: bold;">
                    "TODOS LOS TRÁMITES DE RECLUTAMIENTO, SELECCIÓN E INGRESO SON GRATUITOS"
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="version">
      <p class="text-center">
        Unipol v1.0
      </p>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style scoped></style>
